import React from "react";
import { Tooltip } from "@mui/material";
import moment from "moment-timezone";

function LastUpdateTooltip(props) {
  const tooltipTitle = () => {
    if (props.AgentCommentsModifiedDate && props.AgentCommentsModifiedBy) {
      return `Last update: ${moment
        .utc(props.AgentCommentsModifiedDate)
        .tz("America/New_York")
        .format("YYYY-MM-DD hh:mm:ss A")} by ${props.AgentCommentsModifiedBy}`;
    } else if (props.AgentCommentsModifiedDate) {
      return `Last update: ${moment
        .utc(props.AgentCommentsModifiedDate)
        .tz("America/New_York")
        .format("YYYY-MM-DD hh:mm:ss A")}`;
    } else if (props.AgentCommentsModifiedBy) {
      return `Last update: ${props.AgentCommentsModifiedBy}`;
    } else {
      return "No update data available";
    }
  };

  return (
    <Tooltip title={tooltipTitle()} placement="right">
      {props.children}
    </Tooltip>
  );
}

export default LastUpdateTooltip;
